import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  orderTimeCollectionFromModel,
  validateOrderTimeCollectionCondition,
  type OrderTimeCollectionState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const ORDER_TIME_COLLECTION = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<OrderTimeCollectionState>
  >,
): ConditionType<OrderTimeCollectionState, Condition.OrderTimeCollection> => ({
  name: CONDITION_NAMES[Condition.ORDER_TIME_COLLECTION],
  description(state) {
    return t("Original collections at order time: {{collections}}", {
      collections: state.join(", "),
    });
  },
  Details(props: ConditionTypeDetailsProps<OrderTimeCollectionState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model) {
    return orderTimeCollectionFromModel(model);
  },
  toModel(state) {
    return { type: Condition.ORDER_TIME_COLLECTION, collections: state };
  },
  valid(state) {
    return validateOrderTimeCollectionCondition(state).valid;
  },
});
